module.exports = __webpack_public_path__ + "static/media/instagram.d9ab0737.png";